import { render } from "./PaymentMethods.vue?vue&type=template&id=02849ab6"
import script from "./PaymentMethods.vue?vue&type=script&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "02849ab6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02849ab6', script)) {
    api.reload('02849ab6', script)
  }
  
  module.hot.accept("./PaymentMethods.vue?vue&type=template&id=02849ab6", () => {
    api.rerender('02849ab6', render)
  })

}

script.__file = "src/views/settings/modules/PaymentMethods.vue"

export default script